import { Router } from "@angular/router";
import { FeatureGroup, Marker } from "leaflet";
import { ConnectionMarkerBuilder } from "../builders";
import { Connection, MapSettings } from "../models";
import { MapService } from "../../../core/services";

export class ConnectionsLayerService {
  private activeMarkerId: string | undefined = undefined;
  private connList: Connection[] = [];
  private router!: Router;
  private mapSettings: MapSettings | undefined;
  private highlightedMarkerId: string | undefined = undefined;
  private mapService: MapService | undefined = undefined;

  readonly connLayer = new FeatureGroup;

  init(router: Router, mapService: MapService, mapSettings: MapSettings) {
    this.router = router;
    this.mapService = mapService;
    this.mapSettings = mapSettings;

    this.mapService.highlightId$.subscribe(id => {
      this.connLayer.eachLayer(l => {
        const o = l.options as any;
        if (o.cid == id) {
          l.fireEvent('mouseover');
          this.highlightedMarkerId = id;
        }
      });
    });

    this.mapService.highlightEndId$.subscribe(id => {
      this.connLayer.eachLayer(l => {
        const o = l.options as any;
        if (o.cid == id) {
          l.fireEvent('mouseleave');
          this.highlightedMarkerId = undefined;
        }
      });
    });  
  }

  redraw(connections: Connection[] | undefined = undefined) {
    if (connections)
      this.connList = connections;

    this.connLayer.clearLayers();
    return this.addConnectionMarkers();
  }

  selectMarker(id: string | undefined) {
    this.activeMarkerId = id;
    if (!id)
      this.connLayer.closePopup();
  }

  getConn(connId: string): Connection | undefined {
    return this.connList.find(({ id }) => id === connId);
  }

  private async addConnectionMarkers(): Promise<Marker|undefined> {
    let selectedMarker: Marker | undefined = undefined;
    this.connList.forEach((conn) => {
      const selected: boolean = conn.id == this.activeMarkerId;
      const marker = ConnectionMarkerBuilder.buildMarker(conn, this.mapSettings!, selected);
      this.connLayer.addLayer(marker);
      
      marker.on('click', (e) => { this.activeMarkerId = conn.id; this.router.navigate([`detail/${conn.id}`]) });

      marker.on('mouseover', function () {
        marker.openPopup();
      });

      if (selected || this.highlightedMarkerId == conn.id) {
        marker.openPopup();
        selectedMarker = marker;
      }
      else {
        marker.on('mouseout', function () {
          marker.closePopup();
        });
      }
    });

    this.connLayer.bringToFront();

    return selectedMarker;
  }
}
